import { mount } from "@vue/test-utils";
import CustomInputGroup from "@/components/core/CustomInputGroup";

// Mock the updateValues method
jest.mock("@/components/core/CustomInputGroup", () => ({
  ...jest.requireActual("@/components/core/CustomInputGroup"),
  methods: {
    updateValues: jest.fn()
  }
}));

describe("CustomInputGroup test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(CustomInputGroup, {
      props: {
        value: "asdas"
      }
    });
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component CustomInputGroup", () => {
    expect(wrapper).toBeDefined();
  });
});
